module.exports = __webpack_public_path__ + "img/dialog-bg.820cb28e.png";